"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const cosmos_1 = require("components/cosmos");
const field_1 = __importDefault(require("components/cosmos/field"));
const inputMask_1 = __importDefault(require("components/cosmos/inputMask"));
const translationContext_1 = require("configs/translationContext");
const constants_1 = require("modules/content/constants");
const drippingFormUtil_1 = __importDefault(require("modules/content/dripping/utils/drippingFormUtil"));
const numberOfDayField_module_scss_1 = __importDefault(require("./numberOfDayField.module.scss"));
const ONLY_NUMBERS_MASK = [/\d/, /\d/, /\d/, /\d/];
const NumberOfDaysField = ({ id, labelBeforeInput, labelAfterInput, className, value = '', onChange }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const getErrorMessage = () => {
        if (Number(value) > constants_1.MAX_LIBERATION_DAYS) {
            return t('dripping_2.notifications.maximum_number_of_days', {
                data: {
                    days: constants_1.MAX_LIBERATION_DAYS,
                    years: constants_1.MAX_LIBERATION_DAYS_IN_YEARS
                }
            });
        }
        return t('dripping_2.notifications.minimum_number_of_days');
    };
    const hasError = value !== '' && !drippingFormUtil_1.default.isNumberOfDaysValid(Number(value));
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('_bg-gray-100 _rounded _p-3', className), children: [(0, jsx_runtime_1.jsxs)(field_1.default, { className: "_d-flex _align-items-center _mb-0", children: [(0, jsx_runtime_1.jsx)(cosmos_1.InputLabel, { className: "_my-0", htmlFor: id, children: labelBeforeInput }), (0, jsx_runtime_1.jsx)(inputMask_1.default, { id: id, className: (0, classnames_1.default)(numberOfDayField_module_scss_1.default.numberOfDays, '_mx-3'), guide: false, mask: ONLY_NUMBERS_MASK, value: value, hasError: hasError, onChange: onChange }), (0, jsx_runtime_1.jsx)("label", { className: "_my-0", htmlFor: id, children: labelAfterInput })] }), hasError && ((0, jsx_runtime_1.jsxs)("div", { className: "_bg-red-lighter _rounded _text-red-darkest _d-flex _align-items-center _p-4 _mt-3", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'circle-xmark'], className: "_mr-3 _text-3" }), (0, jsx_runtime_1.jsx)("p", { className: "_my-0", children: getErrorMessage() })] }))] }));
};
exports.default = NumberOfDaysField;
